import { apiPermissionTree, PermissionItemProps } from "apis";
import { AdminContainer } from "layouts/admin/layout";
import { Fragment, lazy, useEffect } from "react";
import { Outlet, useOutletContext } from "react-router-dom";
import PermissionTree from "./Tree";


export const PageAdminPermission = lazy(() => import("./List"));
export const PageAdminPermissionCreate = lazy(() => import("./Add"));
export const PageAdminPermissionUpdate = lazy(() => import("./Edit"));
export const PageAdminPermissionManager = lazy(() => import("./Manager"));

export interface FormPermissionValuesProps extends PermissionItemProps {
    parentId?: number;
}

export const PageAdminPermissionContainer = () => {
    useEffect(() => {
        apiPermissionTree()
    }, [])
    return <Outlet />
}